import * as React from 'react';

const SvgSearchOutline = (props) => (React.createElement("svg", Object.assign({ width: 24, height: 24, fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }, props),
    React.createElement("path", { d: "m22 20.587-4.825-4.825A8.5 8.5 0 0 0 19 10.5C19 5.8 15.2 2 10.5 2S2 5.8 2 10.5 5.8 19 10.5 19a8.5 8.5 0 0 0 5.262-1.825L20.587 22 22 20.587ZM10.5 17A6.503 6.503 0 0 1 4 10.5C4 6.912 6.912 4 10.5 4S17 6.912 17 10.5 14.088 17 10.5 17Z", fill: "currentColor" })));

export { SvgSearchOutline as default };
